import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PRIVACY_CONTACT } from "../../constants/legalPolicy";
import "./LegalFooter.css";

export function LegalFooter({ className = "" }) {
  const { t } = useTranslation();
  return (
    <nav className={`legal-footer ${className}`.trim()} aria-label={t("legalLinks", "Legal")}>
      <Link to="/privacy">{t("privacyPolicy", "Privacy")}</Link>
      <span aria-hidden="true">·</span>
      <Link to="/Termsofuse">{t("terms", "Terms")}</Link>
      <span aria-hidden="true">·</span>
      <Link to="/eula">{t("eulaShort", "App EULA")}</Link>
      <span aria-hidden="true">·</span>
      <a href={`mailto:${PRIVACY_CONTACT}`}>{PRIVACY_CONTACT}</a>
    </nav>
  );
}

export default LegalFooter;
